import {
  all, call, fork, put, takeLatest,
} from "redux-saga/effects";
import * as API from "./api";
import * as Actions from "./actions";

function* loadUserHandler(action) {
  try {
    const { response } = yield call(API.loadUser, action.payload.userId);
    yield put(Actions.loadUser.success(response));
  } catch (error) {
    yield put(Actions.loadUser.failure(error));
  }
}

function* loadUsersHandler(action) {
  try {
    const { response } = yield call(API.loadUsers, action.payload.userId);
    yield put(Actions.loadUsers.success(response));
  } catch (error) {
    yield put(Actions.loadUsers.failure(error));
  }
}

function* loadUsersV2Handler(action) {
  try {
    const { response } = yield call(API.loadUsersV2, action.payload.filters, action.payload.isEdited);
    yield put(Actions.loadUsersV2.success(response));
  } catch (error) {
    yield put(Actions.loadUsersV2.failure(error));
  }
}

function* loadStudentsHandler(action) {
  try {
    const { response } = yield call(API.loadStudents, action.payload.clinicId, action.payload.therapistId);
    yield put(Actions.loadStudents.success(response));
  } catch (error) {
    yield put(Actions.loadStudents.failure(error));
  }
}

function* loadStudentAgreementsHandler() {
  try {
    const { response } = yield call(API.loadStudentAgreements);
    yield put(Actions.loadStudentAgreements.success(response));
  } catch (error) {
    yield put(Actions.loadStudentAgreements.failure(error));
  }
}

function* saveStudentAgreementsHandler(action) {
  try {
    const { response } = yield call(API.saveStudentAgreements, action.payload.agreements);
    yield put(Actions.saveStudentAgreements.success(response));
    
    // change user language
    yield put(Actions.updateStudentLanguage.request(action.payload.lang));
    
    // reload user agreements
    yield put(Actions.loadStudentAgreements.request());
  } catch (error) {
    yield put(Actions.saveStudentAgreements.failure(error));
  }
}

function* updateStudentRequestHandler(action) {
  const { studentId, student } = action.payload;
  try {
    const { response } = yield call(API.updateStudent, studentId, student);
    yield put(Actions.updateStudent.success(response));
  } catch (error) {
    yield put(Actions.updateStudent.failure(error));
  }
}

function* updateStudentLanguageRequestHandler(action) {
  const { languageId } = action.payload;
  try {
    const { response } = yield call(API.updateStudentLanguage, languageId);
    yield put(Actions.updateStudentLanguage.success(response));

    // reload page  - fixes a bug related to student agreements not reloading properly. not the best fix, more of a work-around for now... TODO
    window.location.reload(false);
  } catch (error) {
    yield put(Actions.updateStudentLanguage.failure(error));
  }
}


function* loadStudentFilesHandler(action) {
  try {
    const { response } = yield call(API.loadStudentFiles, action.payload.studentId);
    yield put(Actions.loadStudentFiles.success(response));
  } catch (error) {
    yield put(Actions.loadStudentFiles.failure(error));
  }
}

function* uploadStudentFilesHandler(action) {
  try {
    const { response } = yield call(API.uploadStudentFiles, action.payload.studentId, action.payload.files);
    yield put(Actions.uploadStudentFiles.success(response));
    yield put(Actions.loadStudentFiles.request(action.payload.studentId));
  } catch (error) {
    yield put(Actions.uploadStudentFiles.failure(error));
  }
}

function* loadStudentFileHandler(action) {
  try {
    const { response } = yield call(API.loadStudentFile, action.payload.studentId, action.payload.fileName);
    yield put(Actions.loadStudentFile.success(response));
  } catch (error) {
    yield put(Actions.loadStudentFile.failure(error));
  }
}

function* deleteStudentFileHandler(action) {
  try {
    const { response } = yield call(API.deleteStudentFile, action.payload.studentId, action.payload.fileName);
    yield put(Actions.deleteStudentFile.success(response));
    yield put(Actions.loadStudentFiles.request(action.payload.studentId));
  } catch (error) {
    yield put(Actions.deleteStudentFile.failure(error));
  }
}

function* watchUpdateStudentRequest() {
  yield takeLatest(Actions.UPDATE_STUDENT.REQUEST, updateStudentRequestHandler);
}

function* watchUpdateStudentLanguageRequest() {
  yield takeLatest(Actions.UPDATE_STUDENT_LANGUAGE.REQUEST, updateStudentLanguageRequestHandler);
}

function* watchLoadUser() {
  yield takeLatest(Actions.LOAD_USER_DETAILS.REQUEST, loadUserHandler);
}

function* watchLoadUsers() {
  yield takeLatest(Actions.LOAD_USERS.REQUEST, loadUsersHandler);
}

function* watchLoadUsersV2() {
  yield takeLatest(Actions.LOAD_USERSV2.REQUEST, loadUsersV2Handler);
}

function* watchLoadStudents() {
  yield takeLatest(Actions.LOAD_STUDENTS.REQUEST, loadStudentsHandler);
}

function* watchLoadStudentAgreements() {
  yield takeLatest(Actions.LOAD_STUDENT_AGREEMENTS.REQUEST, loadStudentAgreementsHandler);
}

function* watchSaveStudentAgreements() {
  yield takeLatest(Actions.SAVE_STUDENT_AGREEMENTS.REQUEST, saveStudentAgreementsHandler);
}

function* watchLoadStudentFiles() {
  yield takeLatest(Actions.LOAD_STUDENT_FILES.REQUEST, loadStudentFilesHandler);
}

function* watchDeleteStudentFiles() {
  yield takeLatest(Actions.DELETE_STUDENT_FILE.REQUEST, deleteStudentFileHandler);
}

function* watchUploadStudentFiles() {
  yield takeLatest(Actions.UPLOAD_STUDENT_FILES.REQUEST, uploadStudentFilesHandler);
}

function* watchLoadStudentFile() {
  yield takeLatest(Actions.LOAD_STUDENT_FILE.REQUEST, loadStudentFileHandler);
}

export default function* usersSagas() {
  yield all([
    fork(watchLoadUser),
    fork(watchLoadUsers),
    fork(watchLoadUsersV2),
    fork(watchLoadStudents),
    fork(watchUpdateStudentRequest),
    fork(watchUpdateStudentLanguageRequest),
    fork(watchLoadStudentAgreements),
    fork(watchSaveStudentAgreements),
    fork(watchLoadStudentFiles),
    fork(watchDeleteStudentFiles),
    fork(watchUploadStudentFiles),
    fork(watchLoadStudentFile),
  ]);
}
